import React from 'react'
import Card from "@material-ui/core/Card";
import {FormatNumber, GetNameMonth} from "../../helpers/Helpers";

class ConsumptionsList extends React.Component {

    render() {
        const {data} = this.props;

        return (
            <Card>
                <table className='custom-table'>
                    <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Activa (Kwh/m)</th>
                        <th>Reactiva (Kva/m)</th>
                    </tr>
                    </thead>
                    <tbody>

                    {data.map((val, index) => {
                        return (
                            <tr key={index}>
                                <td>{val.ANO} - {GetNameMonth(val.MES)}</td>
                                <td>{FormatNumber.new(val.ENERGIA_ACTIVA)}</td>
                                <td>{FormatNumber.new(val.ENERGIA_REACTIVA)}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </Card>
        );
    }
}

export default ConsumptionsList